export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("ios-input", {
    mounted(el: HTMLElement, binding) {
      nextTick(() => {
        const { $device } = useNuxtApp();
        if ($device.isIos && $device.isSafari) {
          el.classList.add("ios-input");
          typeof binding.value === "string" && el.classList.add(binding.value);
        }
        el.classList.add("ios-input");
        typeof binding.value === 'string'  &&  el.classList.add(binding.value);
      });
    },
  });
});
